<template>
  <div class="d-flex align-center flex-wrap ga-2">
    <AiAssistLaunchButton
      entity-type="lead"
      :entity-id="leadId"
      profile-key="extract_classify"
      :label="$t('ncrm.ai.actions.leadClassify')"
      :disabled="disabled"
      @error="$emit('error', $event)"
    />
    <v-btn variant="text" color="primary" :loading="loading" @click="$emit('refresh')">
      <v-icon start>mdi-refresh</v-icon>
      {{ $t("ncrm.leads.actions.refresh") }}
    </v-btn>
  </div>
</template>

<script>
import AiAssistLaunchButton from "@/components/ai/AiAssistLaunchButton.vue";

export default {
  name: "NcrmLeadHeaderActions",
  components: {
    AiAssistLaunchButton,
  },
  emits: ["error", "refresh"],
  props: {
    leadId: {
      type: [String, Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
